export default __webpack_public_path__ + "static/media/stamp_cover.0311cff7.png";